import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Grid } from "@mui/material";
import "../../css/styles.css";
import TablaBlog from "./TablaBlog";
import FiltrosBlog from "./FiltrosBlog";

const IndexBlog = () => {
    const history = useHistory();

    const [filtroTexto, setFiltroTexto] = useState("");
    const [filtroCategoria, setFiltroCategoria] = useState("");
    const [filtroEstado, setFiltroEstado] = useState("");

    const handleAgregarArticulo = () => {
        history.push("/blog/agregar");
    };

    return (
        <div className="contenido" style={{ minWidth: 0, width: '100%' }}>
            <div className="header">
                <h2>Blog</h2>
            </div>

            <Grid container spacing={2} sx={{ mt: 2, mb: 2 }} justifyContent={"space-between"} alignItems="center">
                <Grid item xs={12} sm={4} md={3} lg={3} xl={3} className="alignLeft">
                    <button
                        className="boton"
                        onClick={handleAgregarArticulo}
                    >
                        Agregar Artículo
                    </button>
                </Grid>
                <FiltrosBlog
                    filtroTexto={filtroTexto}
                    setFiltroTexto={setFiltroTexto}
                    filtroCategoria={filtroCategoria}
                    setFiltroCategoria={setFiltroCategoria}
                    filtroEstado={filtroEstado}
                    setFiltroEstado={setFiltroEstado}
                />
            </Grid>

            <TablaBlog
                filtroTexto={filtroTexto}
                filtroCategoria={filtroCategoria}
                filtroEstado={filtroEstado}
            />
        </div>
    );
};

export default IndexBlog;
